import React, { useEffect } from 'react';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './AboutUs.css'; // Reuse the same styles

const PrivacyPolicy = () => {
  useEffect(() => {
    // Smooth scroll
    var html_body = $('html, body');
    $('.navbar a , .scroll-down a , .backtotop a').on('click', function () {
      if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          html_body.animate({
            scrollTop: target.offset().top - 65
          }, 1500);
          return false;
        }
      }
    });

    // Preloader
    $(window).on('load', function () {
      $('.preloader').delay(1000).fadeOut(1000);
    });
    setTimeout(() => {
      $('.preloader').fadeOut(1000);
    }, 2000);
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid about-us-container">
        <div className="preloader">
          <div className="frame">
            <div className="center">
              <div className="dot-1"></div>
              <div className="dot-2"></div>
            </div>
          </div>
        </div>

        <section id="privacy-policy-page" className="about-us-section">
          <div className="design-layer"></div>
          <div className="backtotop">
            <a href="#privacy-policy-page"><i className="fa fa-arrow-up" aria-hidden="true"></i></a>
          </div>

          <div className="container zindex">
            <div className="about-hero">
              <h3>Privacy <span className="highlight">Policy</span></h3>
              <p>Your privacy matters to us. Below you’ll find how we collect, use, and protect your information.</p>
            </div>

            <div className="about-content-section">
              <div className="about-card">
                <h2 className="about-section-title"><i className="fa fa-database about-icon"></i> Information We Collect</h2>
                <ul className="about-feature-list">
                  <li><i className="fa fa-check-circle check-style"></i> Account registration details</li>
                  <li><i className="fa fa-check-circle check-style"></i> Customer Refmex data</li>
                  <li><i className="fa fa-check-circle check-style"></i> Usage analytics</li>
                  <li><i className="fa fa-check-circle check-style"></i> Payment info (via third-party processors)</li>
                </ul>
              </div>

              <div className="about-card">
                <h2 className="about-section-title"><i className="fa fa-cogs about-icon"></i> How We Use Information</h2>
                <ul className="about-feature-list">
                  <li><i className="fa fa-check-circle check-style"></i> Provide and improve our services</li>
                  <li><i className="fa fa-check-circle check-style"></i> Process transactions securely</li>
                  <li><i className="fa fa-check-circle check-style"></i> Send important service updates</li>
                  <li><i className="fa fa-check-circle check-style"></i> Analyze usage patterns</li>
                </ul>
              </div>

              <div className="row about-card-group">
                <div className="col-md-6">
                  <div className="about-card flex-grow-1">
                    <h2 className="about-section-title">
                      <i className="fa fa-shield about-icon"></i> Data Protection
                    </h2>
                    <p>We implement industry-standard security measures, including encryption and strict access controls, to safeguard your data.</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="about-card flex-grow-1">
                    <h2 className="about-section-title">
                      <i className="fa fa-external-link about-icon"></i> Third-Party Services
                    </h2>
                    <p>We may use trusted third-party providers for payment, analytics, and hosting — each with its own privacy policy.</p>
                  </div>
                </div>
              </div>

              <div className="about-card">
                <h2 className="about-section-title"><i className="fa fa-refresh about-icon"></i> Policy Updates</h2>
                <p>We may update this policy periodically. Continued use after changes implies acceptance of the new terms.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
